import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboards',
  standalone: true,
  imports: [],
  templateUrl: './dashboards.component.html',
  styleUrl: './dashboards.component.scss'
})
export class DashboardsComponent implements OnInit {

  constructor() {
    // Constructor logic can go here if needed
  }

  ngOnInit(): void {
    // Initialization logic can go here if needed
  }

  // Add any additional methods or properties as needed
}
